module.exports = __webpack_public_path__ + "img/client5.88f37fcd.png";